import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PayuPaymentService } from '../../shared/services/payu-payment.service';
import { ModalController, PopoverController } from '@ionic/angular';
import { PdfService } from '../../shared/services/pdf.service';
import { TableColumnOptionsComponent } from '../../shared/popover/table-column-options/table-column-options.component';

@Component({
  selector: 'app-payu-payment-invoice-view',
  templateUrl: './payu-payment-invoice-view.component.html',
  styleUrls: ['./payu-payment-invoice-view.component.scss'],
})
export class PayuPaymentInvoiceViewComponent implements OnInit {

  @Input() txnId: any;
  invoiceData: any;
  invoiceHtml: SafeHtml = "";

  transactionDetails:any;

  constructor(
    private _payuPaymentService: PayuPaymentService,
    private _modalController: ModalController,
    private _pdfServie: PdfService,
    private _popoverController: PopoverController,
    private _sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this._payuPaymentService.getPayUInvoiceTemplateHtml(this.txnId, localStorage.getItem("CId")).subscribe((data) => {
      this.invoiceData = data;
      this.invoiceHtml = this._sanitizer.bypassSecurityTrustHtml(this.invoiceData);
    });

    this._payuPaymentService.getPaymentTransaction(this.txnId).subscribe({
      next: (data)=>{
        this.transactionDetails = data;
      }
    })
  }

  closeModal() {
    this._modalController.dismiss()
  }

  // Print html review template
  printQuote(): void {
    this._pdfServie.generatePdf(this.invoiceData).subscribe(
      (blob) => {
        const url = URL.createObjectURL(blob);

        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = url;

        iframe.onload = () => {
          iframe.contentWindow?.print();
        };

        document.body.appendChild(iframe);
      },
      (error) => {
        console.error('Error generating PDF:', error);
      }
    );
  }

  downloadQuote(): void {
    this._pdfServie.generatePdf(this.invoiceData, true).subscribe(
      (blob) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `Invoice_${this.txnId}.pdf`;
        link.click();
        URL.revokeObjectURL(link.href);
      },
      (error) => {
        console.error('Error generating PDF:', error);
      }
    );
  }

  async openDownloadPopover(event: any) {
    const popover = await this._popoverController.create({
      component: TableColumnOptionsComponent,
      event: event,
      cssClass: 'popup-component',
      componentProps: {
        optionsData: {
          options: [
            { value: "Download", path: "download" },
            { value: "Print", path: "print" }
          ]
        },
        onPathSelected: (data: any) => this.onPrintOptionSelected(data)
      }
    });
    return await popover.present();
  }

  onPrintOptionSelected(data: any) {
    switch (data.path) {
      case "download": {
        this.downloadQuote();
        break;
      }
      case "print": {
        this.printQuote();
        break;
      }
    }
    this._popoverController.dismiss();
  }
}
